import { Box, Typography } from '@locus-taxy/encore-mui';

export default function SettingsPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 3,
        textAlign: 'center',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h2">Settings</Typography>
      <Typography variant="h6" color="text.secondary">
        This is the main application settings page.
      </Typography>
      <Typography color="text.secondary" maxWidth={400}>
        Configurations and user preferences will be managed here in the future.
      </Typography>
    </Box>
  );
}
